import React from 'react';

import { observer } from 'mobx-react';

import classes from './TitleRow.module.scss';
import { scanIqCurrentSubscriptionPlanStore } from '../../../../stores/scanIqCurrentSubscriptionPlanStore';
import { DiscountChip } from '../../../../components/DiscountChip/DiscountChip';
import { DISCOUNT_TYPE } from '../../../../constants/discountType';
import { BillingPeriodTypeChip } from '../../../../components/BillingPeriodTypeChip/BillingPeriodTypeChip';

const TitleRow = observer(() => {
  const { currentSubscriptionPlan } = scanIqCurrentSubscriptionPlanStore;
  const { subscription, promocode } = currentSubscriptionPlan || {};

  if (!subscription) {
    return <h5 className={classes.title}>No Subscription</h5>;
  }

  return (
    <div className="private-info">
      <h5 className={classes.title}>
        {subscription.name}
        <DiscountChip
          show={subscription.discountType === DISCOUNT_TYPE.PROMOCODE}
          discountPercent={promocode?.discountPercent}
        />
      </h5>
      <BillingPeriodTypeChip billingPeriodType={subscription.billingPeriodType} />
    </div>
  );
});

export { TitleRow };
